/**
 * The purpose of this utility controller is to answer any question regarding levels of authorization.
 * Currently it's for privileges only but should be expanded.
 *
 * This means: profiles, roles, privileges, features, account settings etc.
 *
 * @param model
 * @param constructorData
 * @returns {{applicationType: string}}
 */
define(function (require) {

    var agentLEManager = require('web-agent-utils/agentLEManager');

    var privilegesController = {applicationType: "lpPrivilegesController"};

    //********** Check your privilege **********************************************************************************************

    privilegesController.hasViewHistoryPrivilege = function(){
        // The privilege is 1575.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_HISTORY_LIST);
    };

    privilegesController.hasViewAgentListPrivilege = function(){
        // The privilege is 1574.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_AGENTS_LIST);
    };

    privilegesController.hasSecureFormsViewPrivilege = function(){
        // The privilege is 1558.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_AC_SECURE_FORMS);
    };

    privilegesController.hasViewAllChatsPrivilege = function(){
        // The privilege is 10.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_ALL_CHATS);
    };

    privilegesController.hasViewSkillChatsPrivilege = function(){
        // The privilege is 9.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_SKILL_CHATS);
    };

    privilegesController.isManagerRolePrivilege = function(){
        // TODO: create new privilege that returns true only for manager role, and then replace this function to check on that new privilege.
        // The privilege is 9.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_SKILL_CHATS);
    };

    privilegesController.hasParticipatePrivilege = function(){
        // The privilege is 13 - join only.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.PARTICIPATE_IN_CHATS);
    };

    privilegesController.hasAgentManagerModulePrivilege = function(){
        // The privilege is 1503.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.LE_VIEW_AGENT_MANAGER_MODULE);
    };

    privilegesController.hasCampaignManagerModulePrivilege = function () {
        // The privilege is 1500.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.LE_VIEW_CAMPAIGN_MODULE);
    };

    privilegesController.hasAgentViewPrivilege = function () {
        // The privilege is 1502.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.LE_VIEW_AGENT_MODULE);
    };

    privilegesController.hasUsersViewPrivilege = function () {
        // The privilege is 1501.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.LE_VIEW_USER_MANAGEMENT_MODULE);
    };

    privilegesController.hasMessagingHistoryPrivilege = function () {
        // The privilege is 1713.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.MESSAGING_HISTORY);
    };

    privilegesController.hasLiveVoicePrivilege = function () {
        // The privilege is 1705.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.LIVE_VOICE);
    };

    privilegesController.hasLiveVideoPrivilege = function () {
        // The privilege is 1706.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.LIVE_VIDEO);
    };

    privilegesController.hasCoBrowseViewOnlyWithScrollPrivilege = function () {
        // The privilege is 1707.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.COBROWSE_VIEWONLY_SCROLL);
    };

    privilegesController.hasCoBrowseViewOnlyPrivilege = function () {
        // The privilege is 1708.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.COBROWSE_VIEWONLY);
    };

    privilegesController.hasCoBrowseSharedPrivilege = function () {
        // The privilege is 1709.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.COBROWSE_SHARED);
    };

    privilegesController.hasGenerateSecureFormTokenPrivilege = function () {
        // The privilege is 1728.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.GENERATE_SECURE_FORM_TOKEN);
    };

    privilegesController.hasTakeoverPrivilege = function () {
        // The privilege is 1731.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.TAKEOVER_CONVERSATION);
    };

    privilegesController.hasSetManualSlaPrivilege = function () {
        // The privilege is 1741.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.SET_MANUAL_SLA);
    };

    privilegesController.hasUpdateConsumerProfileViaAPIPrivilege = function () {
        // The privilege is 1750.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.UPDATE_CONSUMER_PROFILE_VIA_API);
    };

    privilegesController.hasViewMessagingSurveysPrivilege = function () {
        // The privilege is 1754.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.VIEW_MESSAGING_SURVEYS);
    };

    privilegesController.hasTransferMessagingConversationToOnlineAndBackSoon = function () {
        // The privilege is 1766.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.TRANSFER_TO_SPECIFIC_AGENT_ONLINE_BACK_SOON);
    };

    privilegesController.hasTransferMessagingConversationToAway = function () {
        // The privilege is 1767.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.TRANSFER_TO_SPECIFIC_AGENT_AWAY);
    };

    privilegesController.hasTransferMessagingConversationToOffline = function () {
        // The privilege is 1768.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.TRANSFER_TO_SPECIFIC_AGENT_OFFLINE);
    };

    privilegesController.hasSendFilesFromLocalFileSystemPrivilege = function () {
        // The privilege is 1771.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.SEND_FILES_FROM_LOCAL_SYSTEM);
    };

    privilegesController.hasSendFilesFromCustomWidgetPrivilege = function () {
        // The privilege is 1777.
        return !!agentLEManager.hasLEPrivilege(lpTag.WebAgent.privileges.privilegeIDs.SEND_FILES_FROM_CUSTOM_WIDGET);

    };

    //****************************** Features *****************************************

    //to be added

    return privilegesController;

});
